export type TimedVersionedEvent = {
  id?: number;
  version?: number;
  startAt: string;
  endAt: string;
};
export type ConfirmedMutation<T> = { event: T | null; generation: number };

// A GET started before a drag can finish after its PATCH. Keep the locally
// confirmed version (or the move being saved) until the server returns newer data.
export function reconcileFetchedEvents<T extends TimedVersionedEvent>(
  fetched: T[],
  confirmed: Map<number, ConfirmedMutation<T>>,
  pending: Map<number, T>,
  range: { startStr: string; endStr: string },
  requestGeneration: number
): T[] {
  const rangeStart = new Date(range.startStr).getTime();
  const rangeEnd = new Date(range.endStr).getTime();
  const inRange = (item: T) => new Date(item.startAt).getTime() < rangeEnd
    && new Date(item.endAt).getTime() > rangeStart;
  const byId = new Map(fetched.filter((item) => item.id != null).map((item) => [item.id!, item]));
  for (const [id, mutation] of confirmed) {
    if (mutation.generation <= requestGeneration) continue;
    const local = mutation.event;
    if (!local) {
      byId.delete(id);
      continue;
    }
    const server = byId.get(id);
    if (server && Number(server.version || 0) > Number(local.version || 0)) {
      continue;
    }
    if (inRange(local)) byId.set(id, local);
    else byId.delete(id);
  }
  for (const [id, local] of pending) {
    if (inRange(local)) byId.set(id, local);
    else byId.delete(id);
  }
  return [...byId.values()];
}
